import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import orderService from '../OrderService';
import { OrderTextBox } from '../OrderTextBox';

export class CustomerInfo extends Component {
    static displayName = CustomerInfo.name;
    constructor(props) {
        super(props);
        const { customerName, customerAge, isRegularCustomer, currentBrand, originalShellScanFileUpload, machineBodyNumber, communicateWithMatchMaker, enclosureDesignReference } = props.model;
        this.state = { options: [], uploading: false, customerName: customerName, customerAge: customerAge, isRegularCustomer: isRegularCustomer, currentBrand: currentBrand, machineBodyNumber: machineBodyNumber, originalShellScanFileUpload: originalShellScanFileUpload, communicateWithMatchMaker: communicateWithMatchMaker, enclosureDesignReference: enclosureDesignReference };
        this.handleLeftChange = this.handleLeftChange.bind(this);
        this.handleRightChange = this.handleRightChange.bind(this);      
        this.handleSelectChanged = this.handleSelectChanged.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        //console.log(props.model);
       
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (target.type === 'radio') {
            let orderNum = this.props.orderNum;
            if (name === "enclosureDesignReference" + orderNum) {
                this.setState({
                    [name]: parseInt(value)
                });
            }
            else {
                this.setState({
                    [name]: value === "1" ? true : false
                });
            }            
        }
        else {
            this.setState({
                [name]: value
            });
        }       
    }

    componentDidMount() {
        this._subscription = orderService.subscribe(() => this.orderCommitting());
        //this.populateProductBand();
    }

    orderCommitting() {
        orderService.updateCustomerInfo(this.state);
    }

    componentWillUnmount() {
        orderService.unsubscribe(this._subscription);
    }

    handleSelectChanged(e) {
        var handler = this.onSelectChanged;
        if (handler) {
            handler(e);
        }
    }
   
    handleLeftChange(e) {
        var handler = this.onLeftChanged;
        if (handler) {
            handler(e);
        }
    }

    handleRightChange(e) {
        var handler = this.onRightChanged;
        if (handler) {
            handler(e);
        }
    }
      
    render() {
        let items = this.props.items;
        if (!items) {
            items = new Array();
            
        }
        let orderNum = this.props.orderNum;

        return (
            <div className="w-full">
                <div className="flex">
                    <div className="border-r border-b border-blue-700 pr-1 pb-1">
                        <div className="flex items-center border-2 border-gray-300 p-1">
                            <div className="">
                                <label className="w-28 truncate"><FormattedMessage id="CustomerName" /><span className="font-bold text-red-600">*</span></label>
                            </div>
                            <div className="">
                                <OrderTextBox classnames="mx-1" name="customerName" value={this.state.customerName ?? ""} onChange={this.handleInputChange} />
                            </div>
                            <div className="">
                                <label className="truncate"><FormattedMessage id="CustomerAge" /></label>
                            </div>
                            <div className="">
                                <OrderTextBox classnames="w-10 ml-1" name="customerAge" value={this.state.customerAge ?? ""} onChange={this.handleInputChange} />
                            </div>
                        </div>                                 
                    </div>
                    <div className="flex-grow flex items-center p-1 border-t border-r border-blue-700">
                        <label className="w-24"><FormattedMessage id="IsRegularCustomer" /></label>
                        <div className="flex">
                            <label className="inline-flex items-center">
                                <input type="radio" name={"isRegularCustomer" + orderNum} value="1" checked={this.state.isRegularCustomer === true} onChange={this.handleInputChange} />
                                <span class="ml-1"><FormattedMessage id="Yes" /></span>
                            </label>
                            <label className="inline-flex items-center">
                                <input className="ml-1" type="radio" name={"isRegularCustomer" + orderNum} value="0" checked={this.state.isRegularCustomer === false} onChange={this.handleInputChange} />
                                <span class="ml-1"><FormattedMessage id="No" /></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col justify-between border-l border-r border-b border-blue-700 text-blue-700">
                <div className="flex items-center pr-1">
                    <div className="bg-blue-700 text-white font-bold p-1">
                            <label className="w-full truncate" ><FormattedMessage id="RequiredForRegularCustomer" /></label>
                    </div>
                    <div className="">
                            <label className="mx-1 truncate" ><FormattedMessage id="CurrentBrand" /></label>
                    </div>
                    <div className="flex-grow pr-1">
                            <OrderTextBox classnames="w-full" name="currentBrand" value={this.state.currentBrand == null || this.state.currentBrand == -1 ? "" : this.state.currentBrand} onChange={this.handleInputChange} />
                    </div>
                </div>
                    <div className="flex items-center border-t border-gray-300 p-1">
                        <div className="">
                            <label className="truncate w-full"><FormattedMessage id="MachineBodyNumber" /></label>
                    </div>
                    <div className="flex-grow pr-1 py-1">
                            <OrderTextBox classnames="w-full" name="machineBodyNumber" value={this.state.machineBodyNumber ?? ""} onChange={this.handleInputChange} />
                    </div>
                </div>
                <div className="grid grid-cols-2 border-t border-gray-300 px-1 w-full">
                    <div className="flex items-center py-2 pr-1">
                            <label className="w-32"><FormattedMessage id="OriginalShellScanFileUpload" /></label>
                        <div className="grid grid-cols-2 gap-x-2">
                            <label className="inline-flex items-center">
                                    <input type="radio" type="radio" name={"originalShellScanFileUpload" + orderNum} value="1" checked={this.state.originalShellScanFileUpload === true} onChange={this.handleInputChange} />
                                    <span class="ml-1"><FormattedMessage id="Yes" /></span>
                            </label>
                            <label className="inline-flex items-center">
                                    <input className="ml-1" type="radio" name={"originalShellScanFileUpload" + orderNum} value="0" checked={this.state.originalShellScanFileUpload === false} onChange={this.handleInputChange} />
                                    <span class="ml-1"><FormattedMessage id="No" /></span>
                            </label>
                        </div>
                    </div>
                        <div className="border-l border-gray-300 pl-2  py-1"><lable><FormattedMessage id="EnclosureDesignReference" /></lable></div>
                </div>
                    <div className="grid grid-cols-2 border-t border-gray-300 px-1">
                        <div className="flex items-center py-1  pr-1">
                            <label className="w-32"><FormattedMessage id="CommunicateWithMatchMaker" /></label>
                        <div className="grid grid-cols-2 gap-x-2">
                            <label className="inline-flex items-center">
                                    <input type="radio" name={"communicateWithMatchMaker" + orderNum} value="1" checked={this.state.communicateWithMatchMaker === true} onChange={this.handleInputChange} />
                                    <span class="ml-1"><FormattedMessage id="Yes" /></span>
                            </label>
                            <label className="inline-flex items-center">
                                    <input className="ml-1" type="radio" name={"communicateWithMatchMaker" + orderNum} value="0" checked={this.state.communicateWithMatchMaker === false} onChange={this.handleInputChange} />
                                    <span class="ml-1"><FormattedMessage id="No" /></span>
                            </label>
                        </div>
                    </div>
                    <div className="border-l border-gray-300 flex gap-x-2 pl-2  py-2">
                        <label className="inline-flex items-center">
                                <input type="radio" name={"enclosureDesignReference" + orderNum} value="0" checked={this.state.isRegularCustomer === true && this.state.enclosureDesignReference === 0 && this.state.originalShellScanFileUpload === true} onChange={this.handleInputChange} />
                                <span className="ml-1"><FormattedMessage id="CopyOriginal" /></span>
                        </label>
                        <label className="inline-flex items-center">
                                <input className="ml-1" type="radio" name={"enclosureDesignReference" + orderNum} value="1" checked={this.state.isRegularCustomer === true && this.state.enclosureDesignReference === 1 && this.state.originalShellScanFileUpload === true} onChange={this.handleInputChange} />
                                <span className="ml-1"><FormattedMessage id="ReferenceProduction" /></span>
                        </label>
                    </div>
                </div>
            </div>
            </div>
                            
           
    );
  }
}